import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { CommonService } from '@product/shared/services/common.service';

@Component({
  selector: 'app-relationship',
  templateUrl: './relationship.component.html',
  styleUrls: ['./relationship.component.less'],
})
export class RelationshipComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() mode: string;
  @Output() submitChanges: EventEmitter<any> = new EventEmitter();
  record: any;

  hasInverse = false;
  color: string;
  constructor(private commonService: CommonService) {}

  ngOnInit(): void {}

  submit() {
    //this.commonService.dropDownMetaData['Tags'] = [];
    //this.submitChanges.emit();
  }

  recordLoaded(record: any) {
    this.record = record;
    if (
      this.record.InverseBaseRelation != null &&
      this.record.InverseBaseRelation !== undefined &&
      this.record.InverseBaseRelation.length !== 0
    ) {
      this.formGroup.get('hasInverse')?.setValue(true);
      this.formGroup
        .get('TitleOfInver')
        ?.setValue(this.record.InverseBaseRelation[0].Title);
      this.formGroup
        .get('CodeOfInver')
        ?.setValue(this.record.InverseBaseRelation[0].Code);
      this.formGroup
        .get('IdOfInver')
        ?.setValue(this.record.InverseBaseRelation[0].Id);
    }
  }

  cleanRecord(record: any) : any{
    delete record.hasInverse;
    delete record.CodeOfInver;
    delete record.TitleOfInver;
    delete record.IdOfInver;

    return record;
  }

  beforeSubmit() {
    const hasInverse = this.formGroup.get('hasInverse')?.value as boolean;
    const idOfInver = this.formGroup.get('IdOfInver')?.value as number;
    const baseRelationId = this.formGroup.get('BaseRelationId')?.value as number;
    if (hasInverse) {
      let inverseBaseRelation = [
        {
          Title: this.formGroup.get('TitleOfInver')?.value as string,
          Code: this.formGroup.get('CodeOfInver')?.value as string,
          Id: idOfInver == null ? 0 : idOfInver,
        },
      ];
      this.formGroup.controls['InverseBaseRelation'].setValue(
        inverseBaseRelation
      );
    }
    else{
      this.formGroup.controls['InverseBaseRelation'].setValue(
        []
      );
    }

    this.formGroup.controls['BaseRelationId'].setValue(baseRelationId == null ? 0 : baseRelationId);
  }

  static controls(mode: string) {
    const controlsToReturn: any = {};
    if (mode === 'edit') {
      controlsToReturn['Id'] = [null, []];
    }

    controlsToReturn['Code'] = [null, [Validators.required]];
    controlsToReturn['Title'] = [null, [Validators.required]];
    controlsToReturn['hasInverse'] = [false, []];

    controlsToReturn['CodeOfInver'] = [null, []];
    controlsToReturn['TitleOfInver'] = [null, []];
    controlsToReturn['IdOfInver'] = [null, []];
    controlsToReturn['BaseRelationId'] = [null, []];

    controlsToReturn['InverseBaseRelation'] = [null, []];

    return controlsToReturn;
  }
}
